<template>
  <div class="users-container">
    <div class="page-header">
      <h3>用户管理</h3>
      <div class="header-actions">
        <el-button type="primary" v-permission="'user:add'" @click="handleAddUser">
          <i class="el-icon-plus"></i> 添加用户
        </el-button>
      </div>
    </div>
    
    <div class="content-wrapper">
      <el-card>
        <div slot="header" class="clearfix">
          <span>用户管理介绍</span>
        </div>
        <div class="card-content">
          <p>此页面包含用户管理的所有功能，您可以在左侧菜单选择具体的操作。</p>
          <div class="feature-list">
            <el-row :gutter="20" style="margin-top: 20px;">
              <el-col :span="12">
                <el-button type="success" @click="$router.push('/users/list')">
                  <i class="el-icon-s-custom"></i> 查看用户列表
                </el-button>
              </el-col>
              <el-col :span="12">
                <el-button type="primary" v-permission="'user:add'" @click="$router.push('/users/add')">
                  <i class="el-icon-plus"></i> 添加新用户
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Users',
  methods: {
    handleAddUser() {
      this.$router.push('/users/add')
    }
  }
}
</script>

<style scoped>
.users-container {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h3 {
  color: #303133;
  font-size: 18px;
}

.content-wrapper {
  margin-top: 20px;
}

.card-content {
  padding: 20px 0;
}

.card-content p {
  color: #606266;
  line-height: 1.6;
}

.feature-list {
  margin-top: 20px;
}
</style>